
interface Step {
  number: number;
  label: string;
  shortLabel: string;
}

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
  steps: Step[];
}

export function ProgressIndicator({ currentStep, totalSteps, steps }: ProgressIndicatorProps) {
  return (
    <div className="bg-gray-50 border-b border-gray-200 px-6 py-6">
      <div className="max-w-4xl mx-auto">
        {/* Step labels */}
        <div className="flex justify-between mb-4">
          {steps.map((step) => (
            <div key={step.number} className="flex-1 text-center">
              <div
                className={`text-xs font-medium ${
                  step.number === currentStep
                    ? 'text-gray-900'
                    : step.number < currentStep
                    ? 'text-gray-600'
                    : 'text-gray-400'
                }`}
              >
                {step.shortLabel}
              </div>
            </div>
          ))}
        </div>

        {/* Progress bar with circles */}
        <div className="relative">
          {/* Background line */}
          <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gray-300 -translate-y-1/2" />

          {/* Progress line */}
          <div
            className="absolute top-1/2 left-0 h-0.5 bg-blue-600 -translate-y-1/2 transition-all duration-300"
            style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
          />

          {/* Step circles */}
          <div className="relative flex justify-between">
            {steps.map((step) => (
              <div
                key={step.number}
                className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-xs font-semibold transition-all duration-300 ${
                  step.number === currentStep
                    ? 'bg-blue-600 border-blue-600 text-white'
                    : step.number < currentStep
                    ? 'bg-blue-600 border-blue-600 text-white'
                    : 'bg-white border-gray-300 text-gray-400'
                }`}
              >
                {step.number < currentStep ? (
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  step.number
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
